import type { Resource } from '../../';
export const product_group_women: Resource = {"default":"Women's"};
